import { render } from "./congestion-chart.vue?vue&type=template&id=0089527f&scoped=true"
import script from "./congestion-chart.vue?vue&type=script&lang=js"
export * from "./congestion-chart.vue?vue&type=script&lang=js"

import "./congestion-chart.vue?vue&type=style&index=0&id=0089527f&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0089527f"]])

export default __exports__